export default function reviewsShow() {
  const btn = document.querySelector(".js-reviews-write");
  const block = document.querySelector(".js-reviews-block");
  const form = document.querySelector(".js-reviews-form");

  btn.addEventListener("click", () => {
    block.classList.add("disable-block");
    form.classList.remove("disable-block");
  });
}
